<template>
  <div
    class="flex flex-col"
  >
    <div class="flex flex-row gradient px-3 pt-3 items-end">
      <img src="@/assets/images/contact-marion.png" alt="support" class="h-20 self-end">
      <div class="flex flex-col justify-end pl-3 pb-2 flex-1">
        <h1 class="text-white">
          Bonjour, je suis Marion du service client d'Apodis
        </h1>
        <p class="text-white">
          Si vous avez besoin d'aide ou une question, je suis là !
        </p>
      </div>
      <BaseButton density="comfortable" class="mb-2" @click="openChat">
        Discuter avec le service client
      </BaseButton>
    </div>
    <div class="p-5 space-y-4">
      <div class="flex flex-col md:flex-row gap-6">
        <BaseCard class="flex-1">
          <BaseCardHeader class="min-h-24 lg:min-h-0 flex items-center">
            Prendre rendez-vous avec le service client
          </BaseCardHeader>
          <BaseCardBody class="flex flex-col min-h-24 justify-center">
            <BaseButton class="self-center" primary prepend-icon="mdi-calendar" @click="contactSupport">
              Prendre rendez-vous
            </BaseButton>
          </BaseCardBody>
        </BaseCard>
        <BaseCard class="flex-1">
          <BaseCardHeader class="min-h-24 lg:min-h-0 flex items-center">
            Télécharger notre module de maintenance
          </BaseCardHeader>
          <BaseCardBody class="flex flex-col min-h-24 justify-center">
            <BaseButton
              class="self-center" primary prepend-icon="mdi-download" variant="outlined"
              @click="downloadScreenConnect"
            >
              Télémaintenance
            </BaseButton>
          </BaseCardBody>
        </BaseCard>
      </div>
      <Accordion v-if="data?.faq?.length" type="single" collapsible>
        <ContentfulFAQItem
          v-for="(item, index) in data.faq"
          :key="index"
          :item="item.fields"
        />
      </Accordion>
    </div>
  </div>
</template>

<script lang="ts" setup>
import BaseCard from "@/core/components/base/BaseCard.vue";
import BaseCardHeader from "@/core/components/base/BaseCardHeader.vue";
import BaseCardBody from "@/core/components/base/BaseCardBody.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import useSwr from "@/core/composables/swr/useSwr";
import {contentfulService} from "@/container";
import ContentfulFAQItem from "@/contentful/components/ContentfulFAQItem.vue";
import {Accordion} from "@/core/components/ui/accordion";
import SupportService from "@/core/services/SupportService";

const linkScreenConnect = 'https://files.santesecure.com/ConnectWiseControl.ClientSetup.exe';

const {data} = useSwr(
    "contenful/faq",
    () => contentfulService().FAQ(),
    contentfulService().swrConfig()
);

/**
 * Download the ScreenConnect client.
 */
const downloadScreenConnect = () => {
    window.open(linkScreenConnect, '_self');
};

/**
 * Open the expert follow-up meeting booking page in a new tab.
 */
const contactSupport = () => {
    SupportService.openExpertFollowUpMeetingWindow();
};

/**
 * Open the HubSpot chat widget.
 */
const openChat = () => {
    window.HubSpotConversations.widget.open();
};
</script>
